import { ActionType, createStandardAction } from "typesafe-actions";

export interface ISettings {
    maxCenterDeviation: number;
    messageFrequency: number;
    requestRadius: number;
    report_formats: {
        [key: string]: boolean;
    }
    reports: {
        [key: string]: boolean;
    }
    video: {
        [key: string]: string;
    }
    journals: {
        journals: {
            [key: string]: boolean
        }
    },
    kkv: any;
    alarmSystem: {
        [key: string]: boolean
    },
}

export interface IVehicleDiagnosticSettings {
    egtsEquipmentDataMaxAge: number;
}

export interface ISettingsState {
    settings: ISettings,
    vehicleDiagnosticSettings: IVehicleDiagnosticSettings
}

const initialState: ISettingsState = {
    settings: {
        journals: {
            journals: {}
        },
        maxCenterDeviation: 0,
        messageFrequency: 0,
        report_formats: {},
        reports: {},
        requestRadius: 0,
        video: {},
        kkv: {},
        alarmSystem: {},
    },
    vehicleDiagnosticSettings: {
        egtsEquipmentDataMaxAge: 0,
    }
};

export enum actionTypes {
    SET_SETTINGS = "SET_SETTINGS",
    SET_VEHICLE_DIAGNOSTIC_SETTINGS = "SET_VEHICLE_DIAGNOSTIC_SETTINGS"
}

export const actions = {
    setSettings: createStandardAction(actionTypes.SET_SETTINGS)<ISettings>(),
    setVehicleDiagnosticSettings: createStandardAction(actionTypes.SET_VEHICLE_DIAGNOSTIC_SETTINGS)<IVehicleDiagnosticSettings>(),
};

type ActionTypes = ActionType<typeof actions>;

const reducer = (state: ISettingsState = initialState, action: ActionTypes): ISettingsState => {
    switch (action.type) {
        case actionTypes.SET_SETTINGS:
            return {
                ...state,
                settings: action.payload
            };
        case actionTypes.SET_VEHICLE_DIAGNOSTIC_SETTINGS:
            return {
                ...state,
                vehicleDiagnosticSettings: action.payload
            };
        default:
            return state;
    }
};

export default reducer;